const jbalvingif = 'https://cdn.obsess-vr.com/umg/J-balvin-neon-resized.gif';
const zhugif = 'https://cdn.obsess-vr.com/umg/ZHU-neon_orange-resized.gif';
const katyPerrygif = 'https://cdn.obsess-vr.com/umg/katy-perry-neon-resized.gif'


export const gifMap = {
    "614152899ed97ea76b0905f0": [
        [zhugif, [-6.032, 3.4, 5.630], [3.142, 0,  3.132], [0.01711, 0.01941, 1]],
        [katyPerrygif, [3.08, 2.670, 3.04], [0.050, -2.968, 0.180], [0.018,0.020, 1]],
        [jbalvingif, [-8.200, 1.750, -2.740], [0, -0.082,-0.030], [0.014, 0.014, 1]],
        [zhugif, [-6.382, 1.840, -2.060], [-3.141, 1.44,  3.162], [0.025, 0.025, 1]],
        [jbalvingif, [-9.742, 1.470, -0.050], [-3.141, 1.48,  -3.131], [0.015, 0.018, 1]]
    ],
    "614152899ed97ea76b0905f1":[
        [jbalvingif, [4.610, 2.570, -8.850], [0.031, -1.612,  0.020], [0.018, 0.016, 1]],
        [zhugif, [-8.080, 4.570, -0.170], [3.141, 1.580,  3.132], [0.025, 0.025, 1]],
        [katyPerrygif, [-3.44, 3.86, 7.980], [-3.122, 0.030, 3.122], [0.0226,0.024, 1]],
        [zhugif, [2.62, 2.4, -3.770], [-0.001, 0.052, -0.01], [0.025, 0.025, 1]],
        [jbalvingif, [-0.06, 1.6, -7.7], [-0.001, 0.052, -0.01], [0.015, 0.015, 1]],

    ],
    "615b792ecd34a271429753de":[
        [katyPerrygif, [-2.360, 2.360, 3.150], [-3.092, 0.060, 3.083], [0.023,0.020, 1]],
        [katyPerrygif, [-7.830, 2.110, 2], [-3.092, 1.620, 3.083], [0.018, 0.020, 1]],
        [zhugif, [-9.910, 1.320, -1.490], [-3.092, 1.620, 3.083], [0.018, 0.020, 1]],
        [jbalvingif, [-9.910, 0.910, -0.010], [-3.092, 1.620, 3.083], [0.009, 0.010, 1]],

    ],
    "615b78b1a1325877e1ac6494": [
        [zhugif, [6.738, 2.73, 5.630], [3.142, 0,  3.132], [0.01711, 0.01941, 1]],
        [jbalvingif, [-6.55, 4.2, -8.850], [0.061, -0.112,  -0.040], [0.028, 0.029, 1]],
        [katyPerrygif, [8.398, 2.03, 1.890], [-3.141, -1.550,  3.132], [0.016, 0.01941, 1]],
        [jbalvingif, [-6.8, 2.47, -0.03], [0.061, 1.548,  -0.07], [0.025, 0.025, 1]],
    ],
    "615b796dd7bb008cbec5b33d": [
        [jbalvingif, [1.960, 1.020, -8.200], [-0.009, -1.572, -0.010], [0.010, 0.008, 1]],
        [katyPerrygif, [-5.660, 4.540, -0.110], [-3.092, 1.510, 3.143], [0.032,0.028, 1]],
        [katyPerrygif, [-3.760, 3.830, -6.130], [-3.092, 3.120, -3.140], [0.032,0.028, 1]],
        [zhugif, [2.010, 1.840, -9.930], [-3.092, 3.120, -3.140], [0.030,0.025, 1]],
        [jbalvingif, [-0.020, 1.170, -9.940], [-3.092, 3.120, -3.140], [0.012,0.013, 1]],
    ],
    "615e9db83e65081526eb2466": [
        [jbalvingif, [8.320, 4.03, 0.26], [-3.121, -1.462, 3.152], [0.028, 0.029, 1]],
        [jbalvingif, [-0.08, 1.760, -1.800], [-3.121, -3.102, -3.161], [0.015, 0.015, 1]],
        [zhugif, [4.15, 3.79, 8.38], [-3.121, -0.052, -3.131], [0.038, 0.038, 1]],
        [katyPerrygif, [-1.64, 1.6, 9.73], [-3.121, -0.052, -3.131], [0.014, 0.017, 1]],
    ]
}
